import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import classnames from "classnames/dedupe";

import CustomButton from "components/custom-button/custom-button";
import { createPortal } from "react-dom";

export const OverflowMenu = ({ children, init }) => {
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

    const menuRef = useRef<HTMLDivElement>(null);
    const innerRef = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            const modalEl = document.getElementsByClassName("modal fade");
            if (!modalEl.length) handleToggleMenu();
        };

        if (isMenuOpen) document.addEventListener("click", handleClickOutside);

        return () => document.removeEventListener("click", handleClickOutside);
    }, [isMenuOpen]);

    const handleToggleMenu = () => setIsMenuOpen((prev) => !prev);

    const menuBox = menuRef.current?.getBoundingClientRect();

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

    const TOP_OFFSET = 5;

    return (
        <div className="overflow-menu-container-relative">
            <div ref={menuRef} className="overflow-menu-container">
                <CustomButton
                    className={classnames("overflow-buttons-menu-btn", "btn", "btn-outline-gt-success", "button-wrapper", {
                        open: isMenuOpen,
                        init: init,
                    })}
                    icon={"chevron-down"}
                    innerRef={innerRef}
                    onClick={handleToggleMenu}
                    text="More"
                    withoutPerm
                />
                {isMenuOpen &&
                    createPortal(
                        <div
                            className="overflow-buttons-menu-container"
                            style={{
                                top: menuBox?.bottom ? menuBox.bottom + TOP_OFFSET + scrollTop : undefined,
                                right: menuBox ? window.innerWidth - menuBox.right + scrollLeft : undefined,
                            }}
                        >
                            <div className="overflow-buttons-menu">{children}</div>
                        </div>,
                        document.body
                    )}
            </div>
        </div>
    );
};
